import { AxiosPromise } from 'axios';
import { http } from 'services';
import * as Types from './types';

export const List = (params?: Types.IApi.List.Params): AxiosPromise<Types.IApi.List.Response> =>
  http.request.get('/api/invites', { params });

export const Create = (data: Types.IApi.Create.Request): AxiosPromise<Types.IApi.Create.Response> =>
  http.request.post('/api/invites', data);

export const Resend = (data: Types.IApi.Resend.Request): AxiosPromise<Types.IApi.Resend.Response> =>
  http.request.post(`/api/invites/${data.id}/resend`);

export const Revoke = (data: Types.IApi.Revoke.Request): AxiosPromise<Types.IApi.Revoke.Response> =>
  http.request.delete(`/api/invites/${data.id}`);

// Access code invites
export const GetByOrganization = (orgId: string, params?: Record<string, string | number | undefined>): AxiosPromise => {
  const searchParams = new URLSearchParams();
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== '') {
        searchParams.set(key, String(value));
      }
    });
  }
  const query = searchParams.toString();
  return http.request.get(`/api/invites/organization/${orgId}${query ? `?${query}` : ''}`);
};

export const Generate = (testId: string, count: number, expiresAt?: string): AxiosPromise =>
  http.request.post(`/api/invites/test/${testId}`, { count, expiresAt });

export const GetByTest = (testId: string): AxiosPromise =>
  http.request.get(`/api/invites/test/${testId}`);

export const Delete = (id: string): AxiosPromise =>
  http.request.delete(`/api/invites/${id}`);

export const Validate = (code: string): AxiosPromise =>
  http.request.get(`/api/invites/validate/${code}`);
